module.exports = __webpack_public_path__ + "img/Proliferation-OVCA_10X_OC.27c4f45e.png";